<template>
    <div>
        <BreadCrumb></BreadCrumb>
        <div v-if="this.loading" class="loaderContainer">
            <dot-loader></dot-loader>
        </div>
        <transition name="fade" mode="out-in">
            <div v-if="!this.loading">
                <h2>{{ this.headline }}</h2>
                <div>
                    <inputFloatLabel :value="this.vuexState.campaign.campaign.customer" :required="true" class="input"
                                     label="Kunde *" @input="changeCustomer"></inputFloatLabel>
                    <inputFloatLabel :value="this.vuexState.campaign.campaign.name" :required="true" class="input"
                                     label="Kampagne *" @input="changeName"></inputFloatLabel>
                    <!--  <SelectDetail :initial="this.vuexState.campaign.campaign.ad_special.name" :required="true" @change="changeAdSpecial" v-model="this.vuexState.campaign.campaign.ad_special.name" class="input"
                                    label="AdSpecial *" :options="this.existingAdSpecials"
                                    :disabled=false></SelectDetail>-->
                    <combo-box :required="true" class="input" :initial="initialAdSpecial"
                               :delete-selected="false" icon="icon-add" :insertion-order-index="0" :medium-index="0"
                               :items="this.existingAdSpecials" label="AdSpecial *" @enter="this.addAdSpecial"
                    ></combo-box>
                    <div v-if="this.adSpecialValidationLoading" class="loader"></div>
                </div>
                <div>
                    <inputFloatLabel :value="this.vuexState.campaign.campaign.contact_person" class="input"
                                     label="Anprechpartner" @input="changeContactPerson" disabled></inputFloatLabel>
                    <SelectDetail :required="true" :initial="this.vuexState.campaign.campaign.department"
                                  @change="changeDepartment" v-model="this.vuexState.campaign.campaign.department"
                                  class="input"
                                  label="Abteilung *" :options="this.existingDepartments"
                                  :disabled=false></SelectDetail>
                    <inputFloatLabel :value="this.vuexState.campaign.campaign.jira_ticket_url" class="input"
                                     label="Jira Ticket (URL)" @input="changeJira"></inputFloatLabel>
                </div>
                <div>
                    <div class="toggleWrapper">
                        <Toggle v-model="manualDetailInput" @toggle="changeManualInput" class="toggle"></Toggle>
                        <span class="toggle toggleText">Manuelle Eingabe der Kampagnen Details</span>
                    </div>
                    <div>
                        <AdaButton v-if="this.route==='editCampaign' && !manualDetailInput" class="submit"
                                   :type="['createButton','grey','noBorder']"
                                   title="Admanager Sync" :loading="savingCampaign"
                                   @click="this.forceUpdateCampaign" icon="icon-interactions"></AdaButton>
                    </div>
                </div>
                <div>
                    <Accordion @toggle="toggle" @deviceTypeChange="this.addElement" @accordionAction="addElement"
                               @deleteElement="deleteElement"
                               @addElement="addElement" :content="this.mediums" actionBarHeader="Medium"
                               :multiple=true></Accordion>
                    <AdaButton icon="icon-add" @click="newMedium" type="fullWidthButton"
                               title="NEUES MEDIUM HINZUFÜGEN"></AdaButton>
                </div>
                <AdaButton v-if="this.route==='createCampaign'" class="submit" type="createButton"
                           title="Kampagne erstellen" :customStyles="{padding:'15px'}"
                           @click="this.createCampaign" :loading="savingCampaign"></AdaButton>
                <AdaButton v-if="this.route==='editCampaign'" class="submit" type="createButton"
                           title="Änderungen speichern" :customStyles="{padding:'15px'}" :loading="savingCampaign"
                           @click="this.updateCampaign" icon="icon-save"></AdaButton>
                <Confirm title="Medium löschen" :show="showConfirmMedium" @close="showConfirmMedium = false;"
                         @oncancel="showConfirmMedium = false;" @onok="this.deleteMedium"><p>Medium wirklich
                    löschen?</p></Confirm>
                <Confirm :key="componentKey" :to="to" :refreshKey="componentKey"
                         title="Möchtest du vorher deine Änderungen speichern?" :show="showConfirmLeave"
                         @close="showConfirmLeave = false;"
                         @onok="this.saveOrUpdate" @oncancel="this.discardChanges">
                </Confirm>
            </div>
        </transition>
    </div>
</template>

<script>
import {RepositoryFactory} from "../../../scripts/RepositoryFactory";
import BreadCrumb from "../../../components/breadCrumb/BreadCrumb";
import InputFloatLabel from "../../../components/inputs/InputFloatLabel";
import SelectDetail from "../../../components/inputs/SelectDetail";
import Confirm from "../../../components/dialog/Confirm";
import Accordion from "../../../components/accordion/Accordion";
import AdaButton from "../../../components/buttons/AdaButton";
import ComboBox from "./ComboBox";
import Toggle from "../../../components/inputs/Toggle";
import moment from "moment";

const AdSpecialsRepository = RepositoryFactory.get('adSpecials');

export default {
    name: "EditCampaign",
    components: {Toggle, ComboBox, AdaButton, Accordion, Confirm, SelectDetail, InputFloatLabel, BreadCrumb},
    data() {
        return {
            componentKey: 0,
            adSpecialValidationLoading: false,
            savingCampaign: false,
            showConfirmLeave: false,
            showConfirmMedium: false,
            existingAdSpecials: [],
            existingDepartments: [{text: 'DSS', value: 'DSS'}, {text: 'DCM', value: 'DCM'}, {
                text: 'DAT',
                value: 'DAT'
            }],
            loading: true,
            next: null,
            from: null,
            to: null,
            fnCreateCampaign: null,
            fnUpdateCampaign: null,
            manualDetailInput: false
        }
    },
    computed: {
        headline() {
            return this.$route.name === 'editCampaign' ? 'Kampagne bearbeiten' : 'Kampagne erstellen';
        },
        vuexState() {
            return this.$store.state;
        },
        mediums() {
            return this.$store.getters['campaign/mediums'];
        },
        route: function () {
            return this.$route.name
        },
        initialAdSpecial() {
            if (this.$route.name === 'editCampaign') {
                return this.vuexState.campaign.campaign.ad_special.name;
            } else {
                return '';
            }
        }
    },
    async mounted() {
        this.fnCreateCampaign = () => {
            this.createCampaign(true);
        };
        this.fnUpdateCampaign = () => {
            this.updateCampaign(true);
        };
        if (this.vuexState.campaign.campaign.contact_person === null || this.vuexState.campaign.campaign.contact_person === '') {
            // eslint-disable-next-line no-undef
            let user = sso.getSsoUser();
            if (user) {
                this.vuexState.campaign.campaign.contact_person = user.mail;
            }
        }
        this.$store.dispatch('sites/fetchAllAdServer').then(() => {
            if (this.$route.name === 'editCampaign') {
                this.$store.dispatch('campaign/fetch', this.$route.params.id).then(() => {
                    if (this.vuexState.campaign.campaign.created_at && moment(this.vuexState.campaign.campaign.created_at).isBefore(moment('2022-10-24'))) {
                        this.manualDetailInput = true;
                        this.changeManualInput(true);
                    }
                    this.loading = false;
                    this.$forceUpdate();
                });
            } else {
                this.loading = false;
            }
            this.$root.$on('saveCampaign', this.fnCreateCampaign);
            this.$root.$on('updateCampaign', this.fnUpdateCampaign);
        });

    },
    beforeDestroy() {
        this.$root.$off('saveCampaign', this.fnCreateCampaign);
        this.$root.$off('updateCampaign', this.fnUpdateCampaign);
    },
    created() {
        this.fetchAdSpecials();
    },
    beforeRouteLeave(to, from, next) {
        if (this.vuexState.campaign.changesMade) {
            this.to = to.path;
            this.from = from;
            this.showConfirmLeave = true;
            this.next = next;
            this.forceRerender();
        } else {
            next();
        }
    },
    methods: {
        saveOrUpdate() {
            if (this.from.name === 'createCampaign') {
                this.createCampaign();
            } else {
                this.updateCampaign();
            }
            this.next();
        },
        discardChanges() {
            this.next();
        },
        forceRerender() {
            this.componentKey += 1;
        },
        async fetchAdSpecials() {
            const {data} = await AdSpecialsRepository.get();
            for (let i = 0; i < data.length; i++) {
                this.existingAdSpecials.push({name: data[i]['name'], id: data[i]['id']});
            }
        },
        changeAdSpecial(adSpecial) {
            this.$store.commit('campaign/setAdSpecialId', adSpecial['id']);
        },
        changeName(name) {
            this.$store.commit('campaign/setName', name);
        },
        changeCustomer(customer) {
            this.$store.commit('campaign/setCustomer', customer);
        },
        changeDepartment(department) {
            this.$store.commit('campaign/setDepartment', department);
        },
        changeJira(jiraLink) {
            this.$store.commit('campaign/setJiraLink', jiraLink);
        },
        changeContactPerson(person) {
            this.$store.commit('campaign/setPerson', person);
        },
        getAdSpecial(adSpecial) {
            for (let i = 0; i < this.existingAdSpecials.length; i++) {
                if (this.existingAdSpecials[i]['text'] === adSpecial) {
                    return this.existingAdSpecials[i]['value'];
                }
            }
            return null;
        },
        async createCampaign(clickedFromHeader = false) {
            clickedFromHeader ? this.$root.$emit('campaignLoader', true) : this.savingCampaign = true;
            await this.$store.dispatch('campaign/save', this);
            clickedFromHeader ? this.$root.$emit('campaignLoader', false) : this.savingCampaign = false;
        },
        async updateCampaign(clickedFromHeader = false) {
            clickedFromHeader ? this.$root.$emit('campaignLoader', true) : this.savingCampaign = true;
            await this.$store.dispatch('campaign/update', {vm: this, id: this.$route.params.id});
            clickedFromHeader ? this.$root.$emit('campaignLoader', false) : this.savingCampaign = false;
        },
        async forceUpdateCampaign() {
            this.savingCampaign = true;
            await this.$store.dispatch('campaign/update', {
                vm: this,
                forceAdManagerSync: true,
                id: this.$route.params.id
            });
            this.savingCampaign = false;
        },
        deleteMedium() {
            this.$store.commit('campaign/deleteMedium', this.currentMediumDeleteIndex);
            this.showConfirmMedium = false;
        },
        deleteElement: function (index) {
            this.currentMediumDeleteIndex = index;
            this.showConfirmMedium = true;
        },
        addElement: function () {
            console.log('addElement');
        },
        newMedium() {
            this.$store.commit('campaign/addMedium');
        },
        toggle(json) {
            this.$store.commit('campaign/changeActiveState', json);
        },
        changeManualInput(bool) {
            this.$store.commit('campaign/changeAutomaticMode', {'automaticLineItemRetrieve': !bool});
        },
        getAdSpecialById(id) {
            for (let i = 0; i < this.existingAdSpecials.length; i++) {
                if (id === this.existingAdSpecials['value']) {
                    return this.existingAdSpecials['text'];
                }
            }
            return '';
        },
        adSpecialAlreadyExists(adspecial) {
            for (let i = 0; i < this.existingAdSpecials.length; i++) {
                if (this.existingAdSpecials[i].name === adspecial.name) {
                    return true;
                }
            }
            return false;
        },
        async addAdSpecial(adSpecial) {
            try {
                if (adSpecial.name !== '') {
                    this.adSpecialValidationLoading = true;
                    if (typeof adSpecial.edited !== 'undefined') {
                        let newAdSpecial = {};
                        newAdSpecial.name = adSpecial.edited;
                        adSpecial = await AdSpecialsRepository.createAdSpecial(newAdSpecial);
                        adSpecial = adSpecial.data.adSpecial;
                        this.existingAdSpecials.push(adSpecial);
                        this.$noty.success('AdSpecial erfolgreich angelegt');
                    }
                    this.changeAdSpecial(adSpecial);
                } else {
                    this.$noty.error('AdSpecial darf nicht leer sein');
                }
                this.adSpecialValidationLoading = false;
            } catch (e) {
                this.adSpecialValidationLoading = false;
                this.$noty.error('Es ist ein Fehler aufgetreten');
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.input {
    display: inline-block;
    margin-right: 20px;
    margin-bottom: 18px;
    width: 280px;
}

.submit {
    margin-top: 1rem;
    width: 20rem;
}

.v-dot {
    margin: auto !important;
}

.loaderContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 10em;
}

::v-deep .inputContainer.setupInfos .iconPadding {
    text-transform: capitalize;
}

::v-deep .accordion.box {
    margin-top: 15px;
}

.loader {
    border: 3px solid;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border-color: $pink transparent transparent;
    animation: spin 1s linear infinite;
    display: inline-block;
    margin: .3rem;
}

@keyframes spin {
    100% {
        transform: rotate(360deg);
        filter: hue-rotate(360deg)
    }
}

.toggleWrapper {
    display: flex;
    align-items: center;
}

.toggle {
    display: inline-flex;
    align-items: center;
}

.toggleText {
    margin-left: 1rem;
}
</style>